<p-confirmDialog key="removeTask"></p-confirmDialog>
<p-dialog
	(close)="close()"
	(onHide)="close()"
	[(visible)]="this.isVisible"
	[autoZIndex]="true"
	[baseZIndex]="90000"
	header="header"
>
	<ng-template pTemplate="header">
		<div *ngIf="this.currentTaskTemplate" class="heading">
			Edit | <span class="font-bold">{{ name }}</span>
		</div>
		<div *ngIf="!this.currentTaskTemplate" class="heading font-bold">Create Task</div>
	</ng-template>
	<p-toast key="{{this.toastKeyName}}"/>
	<div class="container">
		<div *ngIf="this.isLoading" class="progress-spinner">
			<p-progressSpinner></p-progressSpinner>
		</div>
		<form #formDir="ngForm" [formGroup]="tasksForm">
			<div *ngIf="missingSchedule && this.currentTaskTemplate" class="warning-box">
				<i class="pi pi-exclamation-triangle mr-2"></i>
				This task is missing a valid schedule. Please contact support to resolve this issue.
			</div>
			<div *ngIf="!this.currentTaskTemplate" class="flex justify-content-between mt-2">
				<h6>Task Name <span class="red-tick ml-1">{{ this.touchedTaskName }}</span></h6>
				<input
					(change)="touched('taskName')"
					class="w-7"
					formControlName="taskName"
					id="taskName"
					pInputText
					placeholder="e.g. creditcard reconcilliation"
				/>
			</div>

			<div class="flex justify-content-between mt-4">
				<h6 *ngIf="this.currentTaskTemplate" class="mt-2">Update Repeat</h6>
				<h6 *ngIf="!this.currentTaskTemplate" class="mt-2">Repeat <span
					class="red-tick ml-1">{{ this.touchedRepeat }}</span></h6>

				<p-dropdown
					(onBlur)="touched('repeat')"
					(onChange)="onTypeChange($event); touched('repeat')"
					[options]="this.typeOptions"
					class="w-7"
					dataKey="id"
					formControlName="schedule"
					inputId="type"
					optionLabel="displayName"
					placeholder="Select type"
				></p-dropdown>
			</div>

			<h6 *ngIf="this.currentTaskTemplate" class="review font-bold mt-6 mb-2">
				Update Review Stages
			</h6>
			<h6 *ngIf="!this.currentTaskTemplate" class="review font-bold mt-6 mb-2">Review Stages</h6>
			<div class="line"></div>

			<div class="flex justify-content-between mt-4">
				<h6 *ngIf="!this.currentTaskTemplate" class="mt-2">Review Groups<span
					class="red-tick ml-1">{{ this.touchedGroup }}</span></h6>
				<h6 *ngIf="this.currentTaskTemplate" class="mt-2">Update Review Groups</h6>

				<p-dropdown
					#reviewGroupDropdown
					(onBlur)="touched('group')"
					[filter]="true"
					[options]="availableGroups"
					[showClear]="true"
					class="w-7"
					filterBy="displayName"
					formControlName="selectedReviewGroupOption"
					inputId="group"
					optionDisabled="isDisable"
					optionLabel="displayName"
					placeholder="Select group"
				>
					<ng-template let-group pTemplate="selectedItem">
						<div class="flex align-items-center gap-2">
							<div>{{ group.displayName }}</div>
						</div>
					</ng-template>

					<ng-template let-group pTemplate="item">
						<div
							(click)="addGroupToStages(group.displayName, group.id, '')"
							class="flex align-items-center gap-2"
						>
							<div>
								{{ group.displayName }}
							</div>
						</div>
					</ng-template>
				</p-dropdown>
			</div>

			<div *ngFor="let stage of stages; let i = index">
				<div class="list-item">
					<div class="flex justify-content-between">
						<div class="flex">
							<div>Stage {{ i + 1 }} -</div>

							<div class="bold">{{ stage.groupName }}</div>
						</div>

						<p-button
							(click)="removeGroupFromStages(i,stage.groupId)"
							[disabled]="isLoading"
							icon="pi pi-times"
						></p-button>
					</div>
				</div>
			</div>

			<h6 *ngIf="this.currentTaskTemplate" class="review font-bold mt-6 mb-2">
				Update Task Instructions (optional)
			</h6>
			<h6 *ngIf="!this.currentTaskTemplate" class="review font-bold mt-6 mb-2">
				Task Instructions (optional)
			</h6>
			<div class="line"></div>

			<div class="mt-4">
				<div class="left">
					<textarea
						formControlName="description"
						pInputTextarea
						rows="6"
						style="resize: none"
						type="text"
					></textarea>
				</div>
			</div>

			<div class="mt-3 flex justify-content-end">
				<button
					(click)="createOrEditTask()"
					[disabled]="displayAddButton()"
					class="width p-button-rounded button-w"
					label="{{this.currentTaskTemplate? 'Save':'Add'}}"
					pButton
					pRipple
					type="button"
				></button>
			</div>
		</form>

		<div class="danger-zone" *ngIf="currentTaskTemplate">
			<div class="danger-zone" *ngIf="currentTaskTemplate">
				<h6 class="review font-bold mt-6 mb-2">Danger Zone</h6>
				<div class="line mb-1"></div>
				<p class="muted">
					The task will be removed from your task list. Contact support should you need the task reinstated.
				</p>

				<button
					pButton
					type="button"
					class="p-button-danger"
					label="Remove Task"
					(click)="confirmRemoveTask()"
					[disabled]="isLoading">
				</button>
			</div>
		</div>
	</div>
</p-dialog>
